





















































import { Component, Vue } from "vue-property-decorator";
import { passwordRules } from "@/utils/validation";
import { IAuthService } from '@/interfaces/Services';
import { inject } from 'inversify-props';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({})
export default class PasswordResetCard extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;

  private isLoading = false;
  private step = 1;
  private formData = {
    recoveryKey: "",
    email: "",
    password: "",
    confirmPassword: ""
  };

  private visibility = {
    password: false,
    confirmPassword: false,
  }
  private get formConfig() {
    return {
      recoveryKey: {
        label: this.$t("account.recoveryKey"),
        hint: this.$t("account.passwordReset.recoveryKeyHint"),
        rules: [
          (v: string | undefined) =>
            !!v || this.$t("validator.required")
        ]
      },
      password: {
        label: this.$t("account.newPassword"),
        rules: [(v: string | undefined) => !!v || this.$t("validator.required"), ...passwordRules],
      },
      confirmPassword: {
        label: this.$t("account.newPasswordConfirm"),
        rules: [
          (v: string | undefined) =>
            (v && v === this.formData.password) || this.$t("validator.passwordMismatch")
        ],
      }
    };
  }

  async submit() {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    this.isLoading = true;

    try {
      await this.authService.passwordReset(
        this.$route.query.token.toString(),
        this.formData.password,
        this.formData.recoveryKey
      );
      this.step++;
    } catch (e) {
      alert(this.$t("general.unknownErrorOccurred"));
    } finally {
      this.isLoading = false;
    }
  }
}
